import { useEffect, useRef, useState } from "react";

const useBunnerSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const [isFullWidth, setIsFullWidth] = useState(false);
  const [activeTab, setActiveTab] = useState("home");

  // Auto switch tabs
  useEffect(() => {
    const startAutoSwitch = () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }

      timerRef.current = setInterval(() => {
        setActiveTab((prev) => (prev === "home" ? "download" : "home"));
      }, 10000);
    };

    if (isFullWidth) {
      startAutoSwitch();
    } else if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [isFullWidth]);

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);

    // Reset the timer when manually clicking
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    if (isFullWidth) {
      timerRef.current = setInterval(() => {
        setActiveTab((prev) => (prev === "home" ? "download" : "home"));
      }, 10000);
    }
  };
  return {
    handleTabClick,
    sectionRef,
    isFullWidth,
    activeTab,
    setIsFullWidth,
    setActiveTab,
  };
};

export default useBunnerSection;
